<div class="modal-item modal-anim" [ngClass]="item.panelClass" [ngStyle]="modalStyles" #modalWrapper
  (click)="$event.stopPropagation()">
    <div class="modal-close--wrapper">
        <button class="modal-close--button" (click)="onCloseModalClick()">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
    <div *ngIf="item.title || item.tone" class="modal-title">
        <span *ngIf="item.tone" class="modal-tone-icon" aria-hidden="true">
            <i [class]="toneIconClass"></i>
        </span>
        <h1 *ngIf="item.title">{{item.title}}</h1>
        <span *ngIf="item.subtitle">{{item.subtitle}}</span>
    </div>
    <div class="modal-content--wrapper">
        <div [class.modal-content--scroll]="!item.internalScroll" [class.modal-content--full]="item.internalScroll">
            <ng-container #vc></ng-container>
        </div>
        <div *ngIf="item.actions.length>0" class="modal-content--actions">
            <div *ngFor="let action of item.actions">
                <button [ngClass]="action.class" [disabled]="isActionDisabled(action)" (click)="onActionClick(action)">{{action.label}}</button>
            </div>
        </div>
    </div>
</div>
